export default {
  salesDecomposition: 'Decomposição de {kpi}',
  dataView: 'Visualização de Dados',
  close: 'Fechar',
  refresh: 'Atualizar',
  saveAsImage: 'Salvar como Imagem',
  base: 'Base',
  carryOverMarketing: 'Marketing Residual',
  instantMarketing: 'Marketing Instantâneo',
  noise: 'Ruído',
  seasonality: 'Sazonalidade',
  external: 'Externo',
  total: 'Total'
}
